import {
    SEND_INVOICE_NOTIIFICATION_Failed, SEND_INVOICE_NOTIIFICATION_Loading, SEND_INVOICE_NOTIIFICATION_Reset, SEND_INVOICE_NOTIIFICATION_Success
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    data: null,

};

export const SendInvoiceNotificationReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any, error: any, }
) => {
    switch (action.type) {
        case SEND_INVOICE_NOTIIFICATION_Loading:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case SEND_INVOICE_NOTIIFICATION_Success:
            return {
                ...state,
                loading: false,
                data: action.payload,
                status: action.status,
                error: null,

            };

        case SEND_INVOICE_NOTIIFICATION_Failed:
            return {
                ...state,
                loading: false,
                error: action.error,
                data: null,
                status: null
            };

        case SEND_INVOICE_NOTIIFICATION_Reset:
            return initialState;

        default:
            return state;
    }
};
